export class LangKey {
    public OtherLang: string = '';
    public OtherLangShort: string = '';
    public AllAsteriskFields: string = '';
    public AreMandatory: string = '';
    public Notice: string = '';
    public PersonalInfo: string = '';
    public PersonalInfo2: string = '';
    public TollFreeNum: string = '';
    public LocalOr: string = '';
    public TollFree: string = '';
    public ReauiredField: string = '';
    public PasteMsg: string = '';
    public ErrMsgPhone: string = '';
    public Continue: string = '';
    public LoadingPleaseWait: string = '';
    public UnableToLoading: string = '';
    public PhoneExample: string = '';
    public Submit: string = '';
    public SelectLanguage: string = '';
    public Start: string = '';
    public Questions: string = '';
    public Complete: string = '';
    public FillOutAllRequiredFields: string = '';
    public ErrorSubmitting: string = '';
}

export const transEn: LangKey = new LangKey();
transEn.OtherLang = "Français";
transEn.OtherLangShort = "fr";
transEn.AllAsteriskFields = "Please note that all questions marked with a red asterisk (";
transEn.AreMandatory = ") are mandatory items/fields.";
transEn.Start = "Start";
transEn.Questions = "Questions";
transEn.Complete = "Complete";

transEn.SelectLanguage ="Please select language to proceed";
transEn.Notice = "Notice";
transEn.PersonalInfo = "Personal information on this form is collected by the Patient Ombudsman and staff of the Patient Ombudsman under the authority of s. 13.1, 13.2 and 13.3 of the Excellent Care for All Act, 2010, and of the Freedom of Information and Protection of Privacy Act and will be used to contact you and to attempt to facilitate a resolution of a complaint to the Patient Ombudsman, and the information may be used in an investigation by the Patient Ombudsman and staff of the Patient Ombudsman. Questions about this collection should be directed to the Records Management & Privacy Specialist at";
transEn.TollFreeNum = "1.888.321.0339";
transEn.LocalOr = "(local) or";
transEn.TollFree = "(toll-free)";
transEn.PersonalInfo2 = "at Patient Ombudsman.";
transEn.ReauiredField = "Required Field";
transEn.PasteMsg = "There is 4900 character limit, your text will be trimmed if it exceeds the limit";
transEn.ErrMsgPhone = "Please use hyphens (-) as seen in the example, 416-597-0339";
transEn.Continue = "Continue";
transEn.LoadingPleaseWait = "Loading, please wait";
transEn.UnableToLoading = "Sorry, we are unable to load the questionnaire. Either submission is already done or campaign is over";
transEn.PhoneExample = "Example: 416-597-0339";
transEn.Submit = "Submit";
transEn.FillOutAllRequiredFields = "Please fill out the required fields above";
transEn.ErrorSubmitting = "Sorry, there was a problem submitting your response.  Please call us at 416-597-0339 ext. 1960 or email us at LTCH_investigation@patientombudsman.ca";

export const transFr: LangKey = new LangKey();
transFr.OtherLang = "English";
transFr.OtherLangShort = "en";
transFr.AllAsteriskFields = "Tous les champs marqués d’un";
transFr.AreMandatory = "sont obligatoires";
transFr.Start = "Commencer";
transFr.Questions = "Questions";
transFr.Complete = "Compléte";

transFr.SelectLanguage ="Veuillez sélectionner la langue pour continuer";
transFr.Notice = "Avis";
transFr.PersonalInfo = "Tous renseignements, notamment les renseignements personnels et les renseignements personnels sur la santé que vous avez choisi d’inclure dans ce formulaire ainsi que dans toute correspondance de suivi avec le bureau de l’Ombudsman des patients, sont recueillis en vertu des articles 13.2, 13.3 et 13.6 de la Loi de 2010 sur l’excellence des soins pour tous et seront utilisés afin de vous contacter et de tenter de faciliter le règlement de la plainte et, après avoir tenté de faciliter un règlement, l’information pourrait être utilisée pour enquêter sur la plainte. Les questions au sujet de cette collecte doivent être adressées au Spécialiste en matière de confidentialité et de gestion des documents du bureau de l’Ombudsman des patients au";
transFr.TollFreeNum = "1.888.321.0339";
transFr.LocalOr = " (locale) ou";
transFr.TollFree = " (sans frais)";
transFr.PersonalInfo2 = ".";
transFr.ReauiredField = "Champ obligatoire";
transFr.PasteMsg = "Saisir la plainte (Limite de caractères (mots, espaces et chiffres) à 4900)";
transFr.ErrMsgPhone = "S’il vous plaît utiliser des traits d’union (-) comme dans l’exemple ici: 416-597-0339";
transFr.Continue = "Continuer";
transFr.LoadingPleaseWait = "Chargement en cours, veuillez patienter";
transFr.UnableToLoading = "Nous sommes désolés, nous ne pouvons pas charger le questionnaire.  Soit la soumission est déjà complétée, soit l’enquête est terminée.";
transFr.PhoneExample = "Exemple: (416) 597-0339";
transFr.Submit = "Télécharger";
transFr.FillOutAllRequiredFields = "Veuillez remplir les champs obligatoires ci-dessus";
transFr.ErrorSubmitting = "Pardon, un problème est survenu lors de l'envoi de votre réponse. Veuillez nous téléphoner au 416 597-0339, poste 1960, ou nous envoyer un courriel à LTCH_investigation@patientombudsman.ca";

export default function getLangTranslation(lang: string): LangKey {

    if (lang.startsWith("f"))
        return transFr;

    return transEn;
}
